const PRESENTACION_PREFIX = 'BX__';

export const esCodigoPresentacion = (code: string): boolean =>
  code.startsWith(PRESENTACION_PREFIX);

export const extraerCodigoSunat = (code: string): string => {
  if (!esCodigoPresentacion(code)) return code;
  const withoutPrefix = code.slice(PRESENTACION_PREFIX.length);
  const sepIndex = withoutPrefix.indexOf('__');
  return sepIndex >= 0 ? withoutPrefix.slice(0, sepIndex) : withoutPrefix;
};

export const extraerPresentacionId = (code: string): string | null => {
  if (!esCodigoPresentacion(code)) return null;
  const withoutPrefix = code.slice(PRESENTACION_PREFIX.length);
  const sepIndex = withoutPrefix.indexOf('__');
  return sepIndex >= 0 ? withoutPrefix.slice(sepIndex + 2) : null;
};
